import React from 'react';

const PanchakarmaPage = () => {
  return (
    <div className="container mx-auto py-12 px-4 bg-gray-100 font-sans">
      
      <h1 className="text-4xl font-bold text-center mb-12 uppercase text-[#4a6b2e]">Panchakarma</h1>
      
      {/* Articles Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        
        {/* Article 1: What is Panchakarma? */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img 
            src="https://sgtuniversity.ac.in/assets/images/faculty/ims/blogs/understanding-panchakarma-therapy-in-ayurveda.webp" 
            alt="Ayurvedic treatments" 
            className="w-full h-56 object-cover" 
          />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Ayurveda / Panchakarma</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Understanding Panchakarma: The Ultimate Ayurvedic Detox</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Explore the meaning of Panchakarma, its five main procedures, and how it works to cleanse the body and mind.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>

        {/* Article 2: Benefits of Panchakarma */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img 
            src="https://www.jiva.com/img/uploads/1687777945_Blog-Images-3.jpg" 
            alt="Relaxed person" 
            className="w-full h-56 object-cover" 
          />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Ayurveda / Wellness</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">The Surprising Benefits of Panchakarma Therapy</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              From improved digestion and mental clarity to balanced doshas, learn about the many benefits of this ancient purification therapy.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>
        
        {/* Article 3: Preparing for Panchakarma */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img 
            src="https://www.patanjaliwellness.us/wp-content/uploads/2024/06/Ayurvedic-Panchakarma-Treatment-for-Mental-and-Physical-Healing-1024x576.png" 
            alt="Herbs for preparation" 
            className="w-full h-56 object-cover" 
          />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Panchakarma / Prep</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">How to Prepare for Your Panchakarma Treatment</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              A guide to the preparatory phase (Purva Karma) of Panchakarma, including diet and lifestyle changes to get your body ready.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>

        {/* Article 4: The Five Actions */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img 
            src="https://pragatinatural.com/wp-content/uploads/2022/09/Panchakarma.jpg" 
            alt="Ayurvedic treatments" 
            className="w-full h-56 object-cover" 
          />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Panchakarma / Procedures</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Exploring the Five Actions of Panchakarma</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              A detailed overview of each of the five therapies: Vamana, Virechana, Basti, Nasya, and Rakta Mokshana.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>

        {/* Article 5: Post-Panchakarma Care */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img 
            src="https://i.ytimg.com/vi/dTEFa3z-ZTA/maxresdefault.jpg" 
            alt="Healthy meal" 
            className="w-full h-56 object-cover" 
          />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Panchakarma / Aftercare</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Maintaining Your Balance: Life After Panchakarma</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              A guide to the post-treatment phase (Paschat Karma), focusing on diet and lifestyle to maintain the benefits of your therapy.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>

        {/* Article 6: Panchakarma at Home */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img 
            src="https://businessconnectindia.in/wp-content/uploads/2023/08/Panchakarma-Treatment-How-Can-It-Help-You.jpg" 
            alt="Home wellness" 
            className="w-full h-56 object-cover" 
          />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Panchakarma / Home</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Simplified Panchakarma: Safe Practices You Can Do at Home</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Discover gentle and safe ways to incorporate Panchakarma-like practices into your daily routine for ongoing wellness.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default PanchakarmaPage;